'use client';

import { StyledTooltipContainer } from '@components/InternalIcons/Tooltip.styled';
import { openInternalPopup } from '@components/InternalIcons/utils/internalPopup';
import { Box, Tag } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement } from 'react';

type CurrentStoreStockIconProps = {
  stockCount?: number;
  url: string;
  index: number;
  totalIndices: number;
};

const CurrentStoreStockIcon = ({
  stockCount,
  url,
  index,
  totalIndices
}: CurrentStoreStockIconProps): ReactElement => {
  const { trackEvent } = useAnalytics();

  if (stockCount === null || stockCount === undefined) {
    return (
      <Box>
        <Tag variant='subtle'>- in this store</Tag>
      </Box>
    );
  }

  const getMessage = stockCount === 0 ? 'None in this store' : `${stockCount} in this store`;

  const getIntent = stockCount <= 3 ? 'promo' : 'positive';

  return (
    <StyledTooltipContainer
      data-internal-icons-tooltip='Open Iris product dashboard'
      data-testid='current-store-stock-icon'
    >
      <Tag
        onClick={() => {
          trackEvent(
            selectOptionTrigger({
              sub_feature: 'stock_information',
              index: index,
              total_indices: totalIndices,
              selection_type: 'selected',
              option_name: 'current_store_stock_information',
              attribute: 'current_store_stock_information'
            })
          );
          openInternalPopup(url);
        }}
        variant='subtle'
        intent={stockCount === 0 ? undefined : getIntent}
        sx={theme => ({
          cursor: 'pointer',

          ...(stockCount === 0 && {
            color: theme.color.font.interactiveSubtle,
            backgroundColor: theme.color.background.tertiary
          })
        })}
      >
        {getMessage}
      </Tag>
    </StyledTooltipContainer>
  );
};

export default CurrentStoreStockIcon;
